import { Link } from 'react-router-dom';
import { CheckCircle2, ListChecks } from 'lucide-react';
import { Button } from '@/components/ui/Button';

/**
 * Shown in place of the score form once the judge has saved the LAST entry of
 * the category queue. Instead of a dead end it says where they stand and
 * offers the sensible ways onward: jump to what is still unscored, look
 * through the category again, or go back to the queue.
 */
export function JudgeQueueFinish({
  total,
  unscoredCount,
  backHref,
  onGoToFirstUnscored,
  onRestart,
  onBackToLast,
}: {
  total: number;
  unscoredCount: number;
  backHref: string;
  /** Only passed when something is still unscored. */
  onGoToFirstUnscored?: () => void;
  onRestart: () => void;
  onBackToLast: () => void;
}) {
  const allDone = unscoredCount === 0;
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-start gap-3">
        {allDone ? (
          <CheckCircle2 className="mt-0.5 h-6 w-6 shrink-0 text-success" aria-hidden="true" />
        ) : (
          <ListChecks className="mt-0.5 h-6 w-6 shrink-0 text-fg-secondary" aria-hidden="true" />
        )}
        <div>
          <h3 className="font-semibold text-fg">
            {allDone ? 'Vse slike v kategoriji so ocenjene' : 'To je bila zadnja slika v kategoriji'}
          </h3>
          <p className="text-sm text-fg-muted">
            {allDone
              ? `Ocenili ste vseh ${total} slik. Ocene lahko še vedno popravite.`
              : `Ocenili ste ${total - unscoredCount} od ${total} slik, še ${unscoredCount} ${
                  unscoredCount === 1 ? 'je neocenjena' : 'jih je neocenjenih'
                }.`}
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {onGoToFirstUnscored && !allDone && (
          <Button type="button" onClick={onGoToFirstUnscored}>
            Pojdi na prvo neocenjeno
          </Button>
        )}
        <Link to={backHref}>
          <Button type="button" variant={allDone ? 'primary' : 'secondary'}>
            Nazaj na čakalno vrsto
          </Button>
        </Link>
        <Button type="button" variant="ghost" onClick={onRestart}>
          Preglej od začetka
        </Button>
        <Button type="button" variant="ghost" onClick={onBackToLast}>
          Nazaj na zadnjo sliko
        </Button>
      </div>
    </div>
  );
}
